import loadSpinner from './loadSpinner/loadSpinner';
import userBox from './userBox/userBox';

export default angular
  .module('directives', [
    loadSpinner,
    userBox,
  ])
  .name;
